<template>
    <div class="more-block-list">
        <div class="list-item">
            <div v-for="(item, index) in listData" :key="index" class="block-item-wrap">
                <component
                    :is="type(item.resourceType)"
                    :data="item"
                    @editClick="editClick"
                    @deleteClick="deleteClick"
                    @tranferClick="tranferClick"
                    v-show="item.action != 'delete'"
                />
            </div>

            <div class="btn-wrap">
                <div class="mt16">
                    <el-button round type="primary" @click="addVideoClick">{{ $t("zhiji.wiki.addVideo") }}</el-button>
                </div>
                <div>
                    <el-button round type="primary" @click="addTipClick">{{ $t("zhiji.wiki.addTip") }}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipItem from "./TipItem";
import VideoItem from "./VideoItem";
import VideoModal from "../VideoModal";
import TipModal from "../TipModal";
import { uniqueId, genIndexSearchHandler } from "@/views/zhiji/js/common/util.js";

export default {
    name: "MoreBlockList",
    props: ["listData", "lang", "blockData"],
    components: {
        TipItem,
        VideoItem,
        VideoModal,
        TipModal
    },
    model: {
        prop: "listData",
        event: "change"
    },
    data() {
        return {
            type: resourceType => {
                const obj = {
                    video: "VideoItem",
                    tip: "TipItem"
                };
                return obj[resourceType];
            }
        };
    },
    methods: {
        addVideoClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "ReferenceMaterialModal",
                data: {
                    type: "video",
                    confirm: result => {
                        if (result.length > 0) {
                            if (!result[0].lang || result[0].lang !== this.lang) {
                                this.$confirm(this.$t("zhiji.wiki.error.reSelect"), this.$t("zhiji.wiki.error.tip"), {
                                    confirmButtonText: this.$t("zhiji.common.confirm"),
                                    cancelButtonText: this.$t("zhiji.common.cancel"),
                                    type: "warning"
                                })
                                    .then(() => {})
                                    .catch(() => {});
                            } else {
                                this.showVideoModal({
                                    title: this.$t("zhiji.wiki.addVideo"),
                                    resourceId: result[0].id,
                                    lang: this.lang,
                                    sectionId: this.blockData.id,
                                    action: "add",
                                    uId: uniqueId(),
                                    videoUrl: result[0].videoUrl,
                                    formData: {
                                        sectionTitle: this.blockData.sectionTitle,
                                        namePlatform: result[0].platformTitle || "",
                                        name: result[0].title || "",
                                        videoDuration: result[0].duration,
                                        title: result[0].videoLabel,
                                        baseViews: result[0].playNumber || "0",
                                        baseLikeNum: result[0].likeNumber || "0",
                                        viewDate: result[0].showDate
                                            ? result[0].showDate.split(" ")[0] !== "0000-00-00"
                                                ? result[0].showDate.split(" ")[0]
                                                : ""
                                            : "",
                                        image: result[0].url
                                    }
                                });
                            }
                        }
                    }
                }
            });
        },
        showVideoModal(videoData = {}) {
            const _this = this;
            setTimeout(() => {
                this.$store.dispatch("zhiji/showModal", {
                    type: VideoModal,
                    data: {
                        ...videoData,
                        type: "block",
                        rules: {
                            name: [{ required: true, message: this.$t("zhiji.wiki.error.name") }],
                            videoDuration: [{ required: true, message: this.$t("zhiji.wiki.error.duration") }],
                            viewDate: [{ required: true, message: this.$t("zhiji.wiki.error.date") }],
                            title: [{ required: true, message: this.$t("zhiji.wiki.error.title") }],
                            image: [{ required: true, message: this.$t("zhiji.wiki.error.image") }],
                            sectionTitle: [{ required: true, message: this.$t("zhiji.wiki.error.blockTitle") }]
                        },
                        confirm(data) {
                            const { videoUrl } = videoData;
                            data.videoUrl = videoUrl;
                            _this.modalConfirmHandler(data);
                            _this.$emit("chang", _this.listData);
                        }
                    }
                });
            }, 500);
        },
        modalConfirmHandler(data) {
            if (data.action === "add") {
                this.listData.push(data);
            } else {
                this.editConfirmHandler(data);
            }
        },
        editConfirmHandler(data) {
            const spliceIdx = genIndexSearchHandler("uId")(this.listData, data.uId);
            this.listData.splice(spliceIdx, 1, data);
        },
        showTipModal(tipData = {}) {
            const _this = this;
            setTimeout(() => {
                this.$store.dispatch("zhiji/showModal", {
                    type: TipModal,
                    data: {
                        ...tipData,
                        type: "block",
                        rules: {
                            name: [{ required: true, message: this.$t("zhiji.wiki.error.name") }],
                            viewDate: [{ required: true, message: this.$t("zhiji.wiki.error.date") }],
                            title: [{ required: true, message: this.$t("zhiji.wiki.error.title") }],
                            image: [{ required: true, message: this.$t("zhiji.wiki.error.tipImage") }],
                            sectionTitle: [{ required: true, message: this.$t("zhiji.wiki.error.blockTitle") }]
                        },
                        confirm(data) {
                            const { tipContent, tipTitle, tipUpdateTime } = tipData;
                            data.tipContent = tipContent;
                            data.tipTitle = tipTitle;
                            data.tipUpdateTime = tipUpdateTime;

                            _this.modalConfirmHandler(data);
                            _this.$emit("chang", _this.listData);
                        }
                    }
                });
            }, 500);
        },
        addTipClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "ReferenceMaterialModal",
                data: {
                    type: "tip",
                    confirm: result => {
                        if (result.length > 0) {
                            if (!result[0].lang || result[0].lang !== this.lang) {
                                this.$confirm(this.$t("zhiji.wiki.error.reSelect"), this.$t("zhiji.wiki.error.tip"), {
                                    confirmButtonText: this.$t("zhiji.common.confirm"),
                                    cancelButtonText: this.$t("zhiji.common.cancel"),
                                    type: "warning"
                                })
                                    .then(() => {})
                                    .catch(() => {});
                            } else {
                                this.showTipModal({
                                    title: this.$t("zhiji.wiki.addTip"),
                                    lang: this.lang,
                                    resourceId: result[0].id,
                                    action: "add",
                                    uId: uniqueId(),
                                    sectionId: this.blockData.id,
                                    tipContent: result[0].content,
                                    tipTitle: result[0].title,
                                    tipUpdateTime: result[0].updateTime,
                                    formData: {
                                        sectionTitle: this.blockData.sectionTitle,
                                        namePlatform: result[0].platformTitle || "",
                                        name: result[0].title || "",
                                        title: result[0].strategyLabel,
                                        baseViews: result[0].playNumber || "0",
                                        baseLikeNum: result[0].likeNumber || "0",
                                        viewDate: result[0].showDate
                                            ? result[0].showDate.split(" ")[0] !== "0000-00-00"
                                                ? result[0].showDate.split(" ")[0]
                                                : ""
                                            : "",
                                        image: result[0].url
                                    }
                                });
                            }
                        }
                    }
                }
            });
        },
        editClick(data) {
            if (data.resourceType === "video") {
                this.showVideoModal({
                    title: this.$t("zhiji.wiki.editMianVideo"),
                    resourceId: data.resourceId,
                    lang: data.lang,
                    id: data.id,
                    action: "update",
                    uId: data.uId,
                    sectionId: this.blockData.id,
                    videoUrl: data.videoUrl,
                    formData: {
                        ...data,
                        sectionTitle: this.blockData.sectionTitle,
                        title: data.title
                    }
                });
            } else if (data.resourceType === "tip") {
                this.showTipModal({
                    title: this.$t("zhiji.wiki.editMianTip"),
                    resourceId: data.resourceId,
                    lang: data.lang,
                    id: data.id,
                    action: "update",
                    uId: data.uId,
                    tipContent: data.tipContent,
                    tipTitle: data.tipTitle,
                    tipUpdateTime: data.tipUpdateTime,
                    sectionId: this.blockData.id,
                    formData: {
                        ...data,
                        sectionTitle: this.blockData.sectionTitle,
                        title: data.title
                    }
                });
            }
        },
        deleteClick(data) {
            const itemIdx = genIndexSearchHandler("uId")(this.listData, data.uId);
            const newItem = Object.assign({}, this.listData[itemIdx]);
            newItem.action = "delete";
            this.listData.splice(itemIdx, 1);
            this.listData.splice(itemIdx, 0, newItem);

            this.$emit("chang", this.listData);
        },
        tranferClick(data) {
            const itemIdx = genIndexSearchHandler("uId")(this.listData, data.item.uId);
            const item = this.listData[itemIdx];

            if (data.newIdx < 0 || data.newIdx === itemIdx) {
                return;
            }

            this.listData.splice(itemIdx, 1);
            this.listData.splice(data.newIdx, 0, item);
            this.$emit("chang", this.listData);
        }
    }
};
</script>

<style lang="scss" scoped>
.more-block-list {
    padding: 16px;
    width: 100%;
    height: 500px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;

    .list-item {
        position: relative;
        padding: 20px;
        // width: 1600px;
        // overflow-y: scroll;
        display: flex;
    }

    .btn-wrap {
        display: flex;
        flex-direction: column;
    }
    .mt16 {
        margin-bottom: 16px;
    }
}
</style>
